// extracted by mini-css-extract-plugin
module.exports = {"Card":"Card_Card__3a2cp","Animated":"Card_Animated__2ftmN","Image":"Card_Image__3SZLO","Title":"Card_Title__3uyLk","Content":"Card_Content__1jHkV","Link":"Card_Link__17zOU"};